/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/TopicBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./TopicBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.TopicResponse = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.TopicBean);
  }
}(this, function(ApiClient, TopicBean) {
  'use strict';

  /**
   * The TopicResponse model module.
   * @module model/TopicResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>TopicResponse</code>.
   * @alias module:model/TopicResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>TopicResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TopicResponse} obj Optional instance to populate.
   * @return {module:model/TopicResponse} The populated <code>TopicResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('platform'))
        obj.platform = ApiClient.convertToType(data['platform'], 'String');
      if (data.hasOwnProperty('privateKeyFile'))
        obj.privateKeyFile = ApiClient.convertToType(data['privateKeyFile'], 'String');
      if (data.hasOwnProperty('projectId'))
        obj.projectId = ApiClient.convertToType(data['projectId'], 'String');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('serviceAccount'))
        obj.serviceAccount = ApiClient.convertToType(data['serviceAccount'], 'String');
      if (data.hasOwnProperty('topicList'))
        obj.topicList = ApiClient.convertToType(data['topicList'], [TopicBean]);
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} platform
   */
  exports.prototype.platform = undefined;

  /**
   * @member {String} privateKeyFile
   */
  exports.prototype.privateKeyFile = undefined;

  /**
   * @member {String} projectId
   */
  exports.prototype.projectId = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {String} serviceAccount
   */
  exports.prototype.serviceAccount = undefined;

  /**
   * @member {Array.<module:model/TopicBean>} topicList
   */
  exports.prototype.topicList = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/TopicResponse.js